/** import package [start] */
import { useState, useImperativeHandle, forwardRef, useEffect } from 'react';
import { Inputbox } from '@zeeve-platform/inputbox-component';
/** import package [end] */

/** import custom dependency [start] */
import BaseUrls from '../../../utils/baseUrls';
import AWSImage from '../../../assets/cloud-select-0.png';
import DOImage from '../../../assets/cloud-select-1.png';
import GCPImage from '../../../assets/cloud-select-3.png';
import TencentImage from '../../../assets/cloud-select-5.svg';
/** import custom dependency [end] */

type Cloud = {
    name: string;
    image: string;
    value: string;
};

// Third Party Cloud details
const thirdPartyClouds: Cloud[] = [
    {
        name: 'aws',
        image: AWSImage,
        value: 'BYOC_AWS',
    },
    {
        name: 'Digital Ocean',
        image: DOImage,
        value: 'BYOC_DIGITAL_OCEAN',
    },
    {
        name: 'GCP',
        image: GCPImage,
        value: 'BYOC_GCP',
    },
    {
        name: 'Tencent',
        image: TencentImage,
        value: 'BYOC_TENCENT',
    },
];

export interface IFRef {
    isValid: () => boolean;
    getIntraType: () => string;
    getSelectedCloud: () => string;
}

/** type declaration for the Cloud Select component props */
export interface CloudSelectProps {
    onChange?: (cloud: string) => void;
    selectedCloud: string;
    setSelectedCloud: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * Cloud Select component
 * @returns JSX.Element
 */
const CloudSelect = forwardRef<IFRef, CloudSelectProps>(({ onChange, selectedCloud, setSelectedCloud }, ref) => {
    //misc
    const [componentError, setComponentError] = useState<string | null>(null);

    //compoenent dependent states
    const [infraType, setInftraType] = useState<'FirstParty' | 'ThirdParty'>('FirstParty');

    //exposed states and functions
    useImperativeHandle(ref, () => {
        return {
            isValid: () => !componentError,
            getIntraType: () => infraType,
            getSelectedCloud: () => BaseUrls.getItemCode(selectedCloud),
        };
    });

    useEffect(() => {
        if (selectedCloud === '') {
            setComponentError('Please select any one cloud');
        } else {
            setComponentError(null);
        }

        if (onChange) onChange(selectedCloud);
    }, [infraType, selectedCloud]);

    return (
        <>
            <label className='mt-4 fw-bold' style={{ fontWeight: 700 }}>
            {selectedCloud === 'ZEEVE_MANAGED' ? 'Cloud Type' : 'Select Cloud Type'}
            </label>
            <div className='row mt-3 radioleft'>
                {/* <div className='form-check col-xl-5 col-lg-5 col-lg-6 col-sm-12'>
                    <Inputbox
                        className='form-check-input'
                        type='radio'
                        name='cloud-managed'
                        id='externalManaged'
                        checked={infraType === 'ThirdParty'}
                        onChange={() => {
                            setInftraType('ThirdParty');
                            setSelectedCloud('');
                        }}
                    />
                    <label className='form-check-label mx-2' htmlFor='externalManaged'>
                        Bring Your Own Cloud
                        <i
                            title='Configure your own cloud account for hosting of your node.'
                            className='mx-2 fa fa-info-circle'
                        />
                    </label>
                </div> */}
                {/* <div className='form-check col-xl-5 col-lg-5 col-lg-6 col-sm-12'> */}
                <div className='form-check col-12'>
                    <Inputbox
                        className='form-check-input'
                        type='radio'
                        name='cloud-managed'
                        id='zeeveManaged'
                        checked={infraType === 'FirstParty'}
                        onChange={() => {
                            setInftraType('FirstParty');
                            setSelectedCloud('ZEEVE_MANAGED');
                        }}
                    />
                    <label className='form-check-label mx-2' htmlFor='zeeveManaged'>
                        Zeeve Managed Cloud
                        <i
                            title="Choose Zeeve's managed hosting for infrastructure of your node."
                            className='mx-2 fa fa-info-circle'
                        />
                    </label>
                </div>
            </div>
            {infraType === 'ThirdParty' && (
                <div className=''>
                    <div className='row mt-4'>
                        {thirdPartyClouds.map((cloud, index) => {
                            return (
                                <div key={index} className='col-xl-2 col-lg-2 col-md-5 col-sm-5 mx-0'>
                                    <div className='cloud-select cursor'>
                                        <span className='d-flex justify-content-end'>
                                            <Inputbox
                                                className='form-check-input'
                                                type='radio'
                                                id={`cloud-select-${cloud.name}`}
                                                value={cloud.value}
                                                checked={selectedCloud === cloud.value}
                                                onChange={() => {
                                                    setSelectedCloud(cloud.value);
                                                }}
                                            />
                                        </span>
                                        <div className='text-center pt-4 pb-2'>
                                            <img src={cloud.image} alt='' />
                                            <p className='text-muted'>{cloud.name}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {componentError && (
                <div className='alert-danger mt-4 rounded text-center'>
                    <p className='text-danger  py-2'>{componentError}</p>
                </div>
            )}
        </>
    );
});

CloudSelect.displayName = 'CloudSelect';

export default CloudSelect;
